<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="scroll-down-circle"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="Group_999" data-name="Group 999" transform="translate(3 3)">
      <path
        id="Path_8389"
        data-name="Path 8389"
        d="M16,15H8"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : '#fff'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8390"
        data-name="Path 8390"
        d="M8.889,9,12,12.111,15.111,9"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : '#fff'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <circle
        id="Ellipse_120"
        data-name="Ellipse 120"
        cx="9"
        cy="9"
        r="9"
        fill="none"
        :stroke="clr ? clr : '#fff'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path
      id="Path_8391"
      data-name="Path 8391"
      d="M0,0H24V24H0Z"
      transform="translate(24 24) rotate(180)"
      fill="none"
    />
  </svg>
</template>
